export default "__VITE_ASSET__4VuJzEWj__"